import React from 'react'
import { ButtonOLD } from '@lmc/ui-kit'

interface EmarNextStepButtonProps {
  handleNext: () => void
  // Add other props as needed
}

const EmarNextStepButton: React.FC<EmarNextStepButtonProps> = (props) => {
  const { handleNext } = props

  return (
    <ButtonOLD onClick={handleNext} type="primary">
      Next Step
    </ButtonOLD>
  )
}

export default EmarNextStepButton
